/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import AliyunUploads from '../../lib/aliyun-oss/aliyun-upload.js';
import ReactModal from 'react-modal';
import style from './upload-video.css';
// import StompSocket from '../../lib/stompjs/stompSocket.js';
import MonkeyLoading from './monkey-loading.jsx';
import close from './images/close.png';
import SparkMD5 from 'spark-md5';

import {
    getUserToken
} from '../../lib/services/query-params';

const ws = `${API_BASE_URL}/core/create`;
class UploadVideo extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'addFileSuccess',
            'onUploadSucceed',
            'onUploadFailed',
            'onUploadCanceled',
            'onUploadProgress',
            'onUploadEnd',
            'onSocketError',
            'onSocketSubcribe',
            'handleFinished'
        ]);
        this.state = {
            statusText: [],
            videoId: '',
            progress: 0,
            videoFlag: true,
            md5: '',
            videoUrl: ''
        };
        this.aliyunUpload = new AliyunUploads({events: {
            addFileSuccess: this.addFileSuccess,
            onUploadSucceed: this.onUploadSucceed,
            onUploadFailed: this.onUploadFailed,
            onUploadCanceled: this.onUploadCanceled,
            onUploadProgress: this.onUploadProgress,
            onUploadEnd: this.onUploadEnd
        }});

    }

    componentDidMount () {
        this.handleData();
        // this.onSocket('dce75eca7ef045f98f8954379a076b6f');
    }

    componentWillUnmount () {
        // this.closeXsocket();
    }

    closeXsocket () {
        if (this.stomp) {
            // this.stomp.unsubscribe();
            this.stomp.disconnect();
        }
    }

    addFileSuccess () {
        this.setState({
            statusText: ['视频准备上传中...']
        });
    }

    onUploadSucceed (uploadInfo) {
        // 构建视频 URL
        let videoUrl = '';
        
        // 方式1：直接使用 uploadInfo 中的 endpoint、bucket、object（推荐）
        if (uploadInfo.endpoint && uploadInfo.bucket && uploadInfo.object) {
            // 移除 endpoint 中的协议（如果有）
            const endpoint = uploadInfo.endpoint.replace(/^https?:\/\//, '');
            const bucket = uploadInfo.bucket;
            const object = uploadInfo.object;
            
            // 阿里云 OSS 地址格式：https://{bucket}.{endpoint}/{object}
            videoUrl = `https://${bucket}.${endpoint}/${object}`;
        }
        // 方式2：如果方式1失败，尝试解析 uploadAddress（base64 编码的 JSON）
        else if (uploadInfo.uploadAddress) {
            try {
                // uploadAddress 是 base64 编码的 JSON 字符串
                const decodedStr = atob(uploadInfo.uploadAddress);
                const addressInfo = JSON.parse(decodedStr);
                
                if (addressInfo.Endpoint && addressInfo.Bucket && addressInfo.FileName) {
                    const endpoint = addressInfo.Endpoint.replace(/^https?:\/\//, '');
                    const bucket = addressInfo.Bucket;
                    const objectName = addressInfo.FileName;
                    
                    videoUrl = `https://${bucket}.${endpoint}/${objectName}`;
                }
            } catch (e) {
                console.error('解析 uploadAddress 失败', e);
                console.log('uploadAddress 原始值:', uploadInfo.uploadAddress);
            }
        }
        
        this.setState({
            // statusText: '视频上传成功！',
            videoId: uploadInfo.videoId,
            videoUrl: videoUrl,
            md5: this.state.md5
        }, () => {
            this.onVideoSuccess();
        });
        // this.onSocket(uploadInfo.videoId);
    }

    onUploadFailed () {
        this.setState({
            statusText: ['视频上传失败！']
        });
        this.onVideoFailed();
    }

    onUploadCanceled () {
        this.setState({
            statusText: ['视频上传取消！']
        });
    }

    onUploadProgress (uploadInfo, totalSize, progress) {
        const progressPercent = Math.floor(progress * 100);
        this.setState({
            statusText: ['作品上传', '，请稍后…'],
            progress: progressPercent
        });
    }

    onUploadEnd () {
        // this.setState({
        //     statusText: '视频上传完毕！',
        //     statusArray: this.state.statusArray.concat(['视频上传完毕！'])
        // });
    }

    onSocket (videoId) {
        const token = getUserToken();
        const url = `${ws}?token=${token}`;
        // eslint-disable-next-line no-undef
        this.stomp = new StompSocket(url, {});
        this.stomp.on('connected', this.onSocketConnect.bind(this, videoId));
        this.stomp.on(`subscribe/video/${videoId}`, this.onSocketSubcribe);
        this.stomp.on('error', this.onSocketError);
    }

    onSocketError (error) {
        console.log('socket error', error);
        this.onVideoSuccess();
    }

    onSocketConnect (videoId) {
        this.stomp.subscribe(`/video/${videoId}`);
        setTimeout(() => {
            if (this.state.videoFlag) {
                this.onVideoSuccess();
            }
        }, 60000);
    }

    onSocketSubcribe (message) {
        if (message.body) {
            // { "videoId": "503b3fcd46c1407f9ac3665ae27fecdc", "status": 1 }
            try {
                const jsonObj = JSON.parse(message.body) || {};
                if (jsonObj.status === 1) {
                    this.onVideoSuccess();
                }
            } catch (error) {
                console.log('json 解析 error', error);
            }
        }
    }

    handleData () {
        // eslint-disable-next-line react/prop-types
        const {blob} = this.props;
        if (blob){
            // 计算 MD5
            this.calculateBlobMD5(blob).then(md5 => {
                this.setState({md5: md5});
                const title = new Date().getTime();
                this.aliyunUpload.init();
                this.aliyunUpload.addBlobFile(blob, `${title}.webm`, title);
            }).catch(error => {
                console.error('计算 MD5 失败', error);
                // 即使 MD5 计算失败，也继续上传
                const title = new Date().getTime();
                this.aliyunUpload.init();
                this.aliyunUpload.addBlobFile(blob, `${title}.webm`, title);
            });
        }
    }

    /**
     * 计算 blob 的 MD5 值
     * @param {Blob} blob 要计算的文件 blob
     * @returns {Promise<string>} MD5 值
     */
    calculateBlobMD5 (blob) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            const spark = new SparkMD5.ArrayBuffer();
            
            fileReader.onload = (e) => {
                spark.append(e.target.result);
                const md5 = spark.end();
                resolve(md5);
            };
            
            fileReader.onerror = (err) => {
                reject(err);
            };
            
            fileReader.readAsArrayBuffer(blob);
        });
    }

    onVideoSuccess () {
        this.setState({
            progress: 100,
            videoFlag: false
        }, () => {
        });
        // this.closeXsocket();
    }

    onVideoFailed () {
        this.props.onError();
    }

    handleFinished () {
        const {videoId, videoUrl, md5} = this.state;
        // 传递 videoId、videoUrl 和 md5
        this.props.onClick(videoId, videoUrl, md5);
    }


    render () {
        const {
            progress,
            statusText
        } = this.state;
        const expansion = progress < 60 ? 200 : progress > 80 ? 0 : 500;
        return (
            <ReactModal
                overlayClassName={style.overlay}
                className={style.uploadContainer}
                isOpen
                onRequestClose={this.props.onCloseModal}
                shouldCloseOnOverlayClick={false}
            >
                {/* <div className={style.uploadProgress}>
                    {statusArray.map(item => <p key={Math.random()}>{item}</p>)}
                </div> */}
                <MonkeyLoading
                    progress={progress}
                    content={statusText}
                    expansion={expansion}
                    onFinished={this.handleFinished}
                />
                <img
                    className={style.close}
                    onClick={this.props.onCloseModal}
                    src={close}
                />
            </ReactModal>
        );
    }
}

UploadVideo.propTypes = {
    onCloseModal: PropTypes.func,
    onClick: PropTypes.func,
    onError: PropTypes.func
    // blob: PropTypes.blob
};

export default UploadVideo;
